(function () {
  const LOADER_SELECTOR = '.benefits-showcase__icon-loader[data-benefits-icon-url]';

  function hydrateIcon(loader) {
    if (loader.dataset.hydrated === 'true') return;

    const url = loader.dataset.benefitsIconUrl;
    const host = loader.closest('.benefits-showcase__icon');
    if (!url || !host) return;

    fetch(url)
      .then((response) => response.text())
      .then((svgText) => {
        const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
        doc.querySelectorAll('style').forEach((node) => node.remove());
        doc.querySelectorAll('path, circle, polyline, line, rect, ellipse').forEach((node) => {
          node.setAttribute('fill', 'none');
          node.setAttribute('stroke', 'currentColor');
          node.removeAttribute('stroke-width');
        });

        loader.dataset.hydrated = 'true';
        loader.replaceWith(doc.documentElement);
      })
      .catch(() => {});
  }

  function init(root = document) {
    root.querySelectorAll(LOADER_SELECTOR).forEach(hydrateIcon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
